import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { ApiKeyStatus } from '@/types/apiKey';

const STATUS_STYLES: Record<ApiKeyStatus, { label: string; className: string }> = {
  active: {
    get label() { return translateInterfaceText("Ativa"); },
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  revoked: {
    get label() { return translateInterfaceText("Revogada"); },
    className: 'bg-red-50 text-red-700 border-red-200',
  },
  expired: {
    get label() { return translateInterfaceText("Expirada"); },
    className: 'bg-slate-100 text-slate-600 border-slate-200',
  },
};

export function ApiKeyStatusBadge({ status }: { status: ApiKeyStatus }) {
  useLanguage();
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.expired;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-medium ${style.className}`}
    >
      {style.label}
    </span>
  );
}
